import { HeroBackdrop } from './HeroBackdrop';
import { BRANDS } from '../data/brands';
import { ArrowRight } from 'lucide-react';

export function Hero() {
  return (
    <section id="top" className="bg-ink text-cream relative overflow-hidden">
      <HeroBackdrop />

      <div className="relative mx-auto max-w-6xl px-6 pt-44 pb-12 md:pt-56 md:pb-14">
        <p className="mb-6 flex items-center gap-2.5 text-[13px] font-medium text-white/80">
          <span aria-hidden="true" className="size-1.5 rounded-full bg-white/70" />
          Influencer marketing for consumer AI &amp; SaaS brands
        </p>

        <h1 className="max-w-3xl text-[clamp(3rem,6.5vw,5.5rem)] leading-[1.04] font-medium tracking-[-0.055em] text-white">
          Real attention.
          <br />
          <span className="text-white/75">Real results.</span>
        </h1>

        <p className="mt-7 max-w-[31rem] text-base leading-[1.7] text-white/80 md:text-[17px]">
          We build influencer campaigns for consumer AI and SaaS brands, putting your product
          in front of the right people. We find the creators, manage the partnerships, and track
          what moves your brand forward.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <a
            href="#contact"
            className="marketing-button bg-white text-ink hover:bg-white/90"
          >
            Work with us
            <ArrowRight aria-hidden="true" className="size-4" />
          </a>
          <a
            href="#work"
            className="marketing-button border border-white/25 bg-white/5 text-white hover:bg-white/10"
          >
            See the roster
          </a>
        </div>

        <dl className="mt-20 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-white/20 pt-7 text-left sm:grid-cols-3 md:mt-24">
          <Stat label="Creators in network" value="180+" />
          <Stat label="Brands represented" value={`${BRANDS.length}`} />
          <Stat label="Markets" value="US · LATAM · EU" />
        </dl>
      </div>
    </section>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="last:col-span-2 sm:last:col-span-1">
      <dt className="text-xs text-white/65">{label}</dt>
      <dd className="mt-2 text-xl font-medium tracking-[-0.025em] text-white md:text-2xl">{value}</dd>
    </div>
  );
}
